<!-- CONSULTAS → CUADRE DEL DÍA (CCP-10..12). El cálculo de la liquidación de un cierre, paso a paso, con asiento sugerido y registrado. -->
<div class="flex flex-col gap-[20px] min-w-0" [attr.aria-busy]="!r && !error">

  <section class="kb-card">
    <div class="kb-card-header"><div>
      <h2 class="kb-card-title flex items-center gap-2"><i class="fas fa-balance-scale text-muted-foreground" aria-hidden="true"></i>Cuadre del día</h2>
      <p class="kb-card-desc">Cómo se calcula lo que se le paga a cada comercio en un cierre, en bolívares a la tasa del cierre. Solo lectura.</p>
    </div></div>
    <div class="flex flex-col gap-[16px] px-[24px] py-[20px]">
      <div class="flex flex-col sm:flex-row sm:flex-wrap sm:items-end gap-3">
        <label class="kb-label" for="cdDia">Cierre del día
          <input type="date" class="kb-input sm:!w-[170px]" id="cdDia" [(ngModel)]="f.dia" [max]="hoy" (change)="cambiarFiltro()">
        </label>
        <label class="kb-label" for="cdComercio">Comercio
          <select class="kb-select sm:!w-[220px]" id="cdComercio" [(ngModel)]="f.comercio" (change)="cambiarFiltro()">
            <option value="">Todos los comercios</option>
            <option *ngFor="let c of comercios" [value]="c">{{ c }}</option>
          </select>
        </label>
        <div class="flex flex-col sm:flex-row gap-2 sm:ml-auto">
          <button type="button" class="kb-btn kb-btn-outline" [disabled]="bajando.excel || !r" (click)="bajarExcel()"><i class="fas fa-file-excel" aria-hidden="true"></i>Bajar Excel</button>
          <button type="button" class="kb-btn kb-btn-outline" [disabled]="bajando.pdf || !r" (click)="bajarPdf()"><i class="fas fa-file-pdf" aria-hidden="true"></i>Bajar PDF</button>
        </div>
      </div>
      <p class="kb-hint m-0" *ngIf="avisoFecha" role="status">{{ avisoFecha }}</p>
      <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
        <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i><div><p class="m-0">{{ error }}</p></div>
      </div>
    </div>
  </section>

  <!-- Proyección y aviso del tesorero -->
  <div class="kb-aviso kb-aviso-info" *ngIf="r?.proyeccion" role="status">
    <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i>
    <div><p class="m-0"><strong>El cierre del {{ corto(r.dia) }} aún no está cerrado: es una proyección.</strong> {{ r.aviso }}<ng-container *ngIf="r.tasa"> Tasa BCV {{ r.tasa | number:'1.2-4':'es' }} (la del día del cierre).</ng-container></p></div>
  </div>
  <div class="kb-aviso kb-aviso-info" *ngIf="r" role="note">
    <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i>
    <div><p class="m-0">Los asientos son una sugerencia: <strong>los registra el tesorero</strong>, este reporte solo los propone.</p></div>
  </div>

  <!-- Tarjetas -->
  <section class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4" aria-label="Resumen" *ngIf="r; else skTarjetas">
    <div class="kb-card p-[18px] flex flex-col gap-1.5 min-w-0 !border-2 !border-foreground">
      <span class="text-sm text-muted-foreground">Neto a pagar</span>
      <span class="text-[26px] font-bold tabular-nums text-foreground break-words">{{ fb(r.neto_a_pagar.neto_a_pagar_bs) }}</span>
      <span class="text-xs text-muted-foreground tabular-nums">{{ r.proyeccion ? 'Proyección' : 'Lote ' + fb(r.neto_a_pagar.lote_neto_bs) }}</span>
    </div>
    <div class="kb-card p-[18px] flex flex-col gap-1.5 min-w-0">
      <span class="text-sm text-muted-foreground">Neto de la liquidación</span>
      <span class="text-[26px] font-bold tabular-nums text-foreground break-words">{{ fb(r.pasos.neto.bs) }}</span>
      <span class="text-xs text-muted-foreground tabular-nums">{{ fu(r.pasos.neto.usd) }} · {{ nn(r.pasos.credito.n) }} abonos</span>
    </div>
    <div class="kb-card p-[18px] flex flex-col gap-1.5 min-w-0">
      <span class="text-sm text-muted-foreground">Flat fee</span>
      <span class="text-[26px] font-bold tabular-nums text-foreground break-words">{{ fb(r.pasos.flat.bs) }}</span>
      <span class="text-xs text-muted-foreground tabular-nums">{{ fu(r.pasos.flat.usd) }} · {{ nn(r.pasos.flat.n) }} ventas</span>
    </div>
    <div class="kb-card p-[18px] flex flex-col gap-1.5 min-w-0">
      <span class="text-sm text-muted-foreground">Asientos registrados</span>
      <span class="text-[26px] font-bold tabular-nums text-foreground break-words">{{ fb(r.neto_a_pagar.asientos_bs) }}</span>
      <span class="text-xs text-muted-foreground tabular-nums">{{ nn(r.asiento_registrado?.length) }} renglones del lote</span>
    </div>
  </section>

  <ng-container *ngIf="r; else skResto">

    <!-- Paso a paso -->
    <section class="kb-card min-w-0">
      <div class="kb-card-header"><div>
        <h2 class="kb-card-title">Cálculo paso a paso</h2>
        <p class="kb-card-desc">Descuentos en Bs a la tasa del cierre<ng-container *ngIf="r.tasa"> ({{ r.tasa | number:'1.2-4':'es' }})</ng-container>. La comisión total puede variar unos centavos por redondeo.</p>
      </div></div>
      <div class="kb-table-envoltorio">
        <table class="kb-table">
          <thead class="kb-thead"><tr><th class="kb-th">Concepto</th><th class="kb-th kb-th-num">Cantidad</th><th class="kb-th kb-th-num">Bs</th><th class="kb-th kb-th-num">USD</th></tr></thead>
          <tbody>
            <tr class="kb-tr"><td class="kb-td">Crédito liquidado (cuentas CT)</td><td class="kb-td kb-td-num">{{ nn(r.pasos.credito_normal.n) }} abonos</td><td class="kb-td kb-td-num">{{ fb(r.pasos.credito_normal.bs) }}</td><td class="kb-td kb-td-num">{{ fu(r.pasos.credito_normal.usd) }}</td></tr>
            <tr class="kb-tr"><td class="kb-td">+ Abono del nuevo contrato<span class="kb-td-sub block" *ngIf="r.nuevo_contrato_desde">Desde el {{ r.nuevo_contrato_desde | date:'dd/MM/yyyy' }}</span></td><td class="kb-td kb-td-num">{{ nn(r.pasos.abono_nuevo.n) }} abonos</td><td class="kb-td kb-td-num">{{ fb(r.pasos.abono_nuevo.bs) }}</td><td class="kb-td kb-td-num">{{ fu(r.pasos.abono_nuevo.usd) }}</td></tr>
            <tr class="kb-tr font-semibold bg-muted/50"><td class="kb-td">= Crédito liquidado</td><td class="kb-td kb-td-num">{{ nn(r.pasos.credito.n) }} abonos</td><td class="kb-td kb-td-num">{{ fb(r.pasos.credito.bs) }}</td><td class="kb-td kb-td-num">{{ fu(r.pasos.credito.usd) }}</td></tr>
            <tr class="kb-tr"><td class="kb-td">− Comisión de la liquidación</td><td class="kb-td kb-td-num"></td><td class="kb-td kb-td-num">{{ fb(r.pasos.comision.bs) }}</td><td class="kb-td kb-td-num">{{ fu(r.pasos.comision.usd) }}</td></tr>
            <tr class="kb-tr"><td class="kb-td">− Flat fee, USD 1 por venta</td><td class="kb-td kb-td-num">{{ nn(r.pasos.flat.n) }} ventas</td><td class="kb-td kb-td-num">{{ fb(r.pasos.flat.bs) }}</td><td class="kb-td kb-td-num">{{ fu(r.pasos.flat.usd) }}</td></tr>
            <tr class="kb-tr font-semibold bg-muted/50"><td class="kb-td">= Neto de la liquidación</td><td class="kb-td kb-td-num"></td><td class="kb-td kb-td-num">{{ fb(r.pasos.neto.bs) }}</td><td class="kb-td kb-td-num">{{ fu(r.pasos.neto.usd) }}</td></tr>
            <tr class="kb-tr" *ngFor="let a of r.asiento_sugerido?.lineas">
              <td class="kb-td">{{ signo(a.signo) }} {{ a.concepto }} <span class="kb-badge kb-badge-neutro ml-2">Asiento sugerido</span></td><td class="kb-td kb-td-num"></td><td class="kb-td kb-td-num">{{ fb(a.bs) }}</td><td class="kb-td kb-td-num">{{ fu(a.usd) }}</td>
            </tr>
            <tr class="kb-tr" *ngFor="let a of r.asiento_registrado">
              <td class="kb-td">{{ signo(a.signo) }} {{ a.concepto }} <span class="kb-badge kb-badge-neutro ml-2">Asiento registrado en el lote</span></td><td class="kb-td kb-td-num"></td><td class="kb-td kb-td-num">{{ fb(a.monto_bs) }}</td><td class="kb-td kb-td-num">—</td>
            </tr>
            <tr class="kb-tr font-bold border-t-2 border-foreground"><td class="kb-td">= Neto a pagar</td><td class="kb-td kb-td-num"></td><td class="kb-td kb-td-num">{{ fb(r.neto_a_pagar.neto_a_pagar_bs) }}</td><td class="kb-td kb-td-num">—</td></tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- Asiento sugerido y registrado, uno al lado del otro -->
    <section class="kb-card min-w-0">
      <div class="kb-card-header"><div>
        <h2 class="kb-card-title">Asientos: sugerido y registrado</h2>
        <p class="kb-card-desc">El tesorero los registra al cerrar el lote, sin aprobación adicional.</p>
      </div></div>
      <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 px-[24px] py-[20px]">
        <div class="flex flex-col gap-1 min-w-0">
          <span class="text-sm text-muted-foreground">Asiento sugerido</span>
          <span class="text-[22px] font-bold tabular-nums break-words">{{ fb(r.asiento_sugerido?.total_bs) }}</span>
          <span class="text-xs text-muted-foreground tabular-nums">{{ r.asiento_sugerido ? fu(r.asiento_sugerido.total_usd) : (r.puente_nota || 'Este cierre no tiene cortes: no hay asiento que sugerir') }}</span>
        </div>
        <div class="flex flex-col gap-1 min-w-0">
          <span class="text-sm text-muted-foreground">Asiento registrado</span>
          <span class="text-[22px] font-bold tabular-nums break-words">{{ fb(r.neto_a_pagar.asientos_bs) }}</span>
          <span class="text-xs text-muted-foreground">{{ r.asiento_registrado?.length ? 'Lo registró el tesorero en el lote' : 'Lo registra el tesorero' }}</span>
        </div>
        <div class="flex flex-col gap-1 min-w-0">
          <span class="text-sm text-muted-foreground">Diferencia</span>
          <span class="text-[22px] font-bold tabular-nums break-words">{{ fb(r.asiento_sugerido?.diferencia_bs) }}</span>
          <span class="text-xs text-muted-foreground">Sugerido menos registrado</span>
        </div>
      </div>
      <div class="kb-table-envoltorio">
        <table class="kb-table">
          <thead class="kb-thead"><tr><th class="kb-th">Asiento</th><th class="kb-th kb-th-num">Bs</th><th class="kb-th kb-th-num">USD</th><th class="kb-th">Estado</th></tr></thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let a of r.asiento_sugerido?.lineas">
              <td class="kb-td">{{ a.concepto }}</td><td class="kb-td kb-td-num">{{ fb(a.bs) }}</td><td class="kb-td kb-td-num">{{ fu(a.usd) }}</td><td class="kb-td"><span class="kb-badge kb-badge-neutro">Asiento sugerido</span></td>
            </tr>
            <tr class="kb-tr" *ngFor="let a of r.asiento_registrado">
              <td class="kb-td">{{ a.concepto }}<span class="kb-td-sub block">{{ a.payable }}</span></td><td class="kb-td kb-td-num">{{ signo(a.signo) }} {{ fb(a.monto_bs) }}</td><td class="kb-td kb-td-num">—</td><td class="kb-td"><span class="kb-badge kb-badge-neutro">Asiento registrado</span></td>
            </tr>
            <tr class="kb-tr" *ngIf="!r.asiento_sugerido?.lineas?.length && !r.asiento_registrado?.length">
              <td class="kb-td" colspan="4"><span class="text-muted-foreground">Sin asientos para este cierre: los registra el tesorero.</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <div class="grid grid-cols-1 xl:grid-cols-2 gap-[20px] min-w-0">
      <!-- Cobrado en cuentas CT -->
      <section class="kb-card min-w-0">
        <div class="kb-card-header"><div>
          <h2 class="kb-card-title">Cobrado en cuentas CT, por cuenta</h2>
          <p class="kb-card-desc">Lo liquidado, por la cuenta donde se cobró.</p>
        </div></div>
        <div class="kb-table-envoltorio">
          <table class="kb-table">
            <thead class="kb-thead"><tr><th class="kb-th">Cuenta</th><th class="kb-th kb-th-num">Abonos</th><th class="kb-th kb-th-num">USD</th></tr></thead>
            <tbody>
              <tr class="kb-tr" *ngFor="let c of r.cobrado_ct.cuentas"><td class="kb-td">{{ c.nombre }}</td><td class="kb-td kb-td-num">{{ nn(c.n) }}</td><td class="kb-td kb-td-num">{{ fu(c.usd) }}</td></tr>
              <tr class="kb-tr"><td class="kb-td font-semibold">Total CT</td><td class="kb-td kb-td-num font-semibold">{{ nn(r.cobrado_ct.n) }}</td><td class="kb-td kb-td-num font-semibold">{{ fu(r.cobrado_ct.usd) }}</td></tr>
            </tbody>
          </table>
        </div>
      </section>
      <!-- Flat fee por día -->
      <section class="kb-card min-w-0">
        <div class="kb-card-header"><div>
          <h2 class="kb-card-title">Flat fee por día de venta</h2>
          <p class="kb-card-desc">USD 1 por venta firme; sale por cada día de venta que cubre el cierre.</p>
        </div></div>
        <div class="kb-table-envoltorio">
          <table class="kb-table">
            <thead class="kb-thead"><tr><th class="kb-th">Día</th><th class="kb-th kb-th-num">Ventas firmes</th><th class="kb-th kb-th-num">USD</th></tr></thead>
            <tbody>
              <tr class="kb-tr" *ngFor="let d of r.flat_por_dia.dias"><td class="kb-td tabular-nums whitespace-nowrap">{{ d.dia }}</td><td class="kb-td kb-td-num">{{ nn(d.n) }}</td><td class="kb-td kb-td-num">{{ fu(d.usd) }}</td></tr>
              <tr class="kb-tr"><td class="kb-td font-semibold">Total</td><td class="kb-td kb-td-num font-semibold">{{ nn(r.flat_por_dia.n) }}</td><td class="kb-td kb-td-num font-semibold">{{ fu(r.flat_por_dia.usd) }}</td></tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <!-- Cobrado en cuentas MT -->
    <section class="kb-card min-w-0">
      <div class="kb-card-header"><div>
        <h2 class="kb-card-title">Cobrado en cuentas MT: qué se descuenta</h2>
        <p class="kb-card-desc">Dinero que el cliente pagó en cuentas de MT: la comisión y los fees quedan para CT.<ng-container *ngIf="r.puente_mt?.ventana"> Ventana: del {{ r.puente_mt.ventana.desde }} al {{ r.puente_mt.ventana.hasta }}.</ng-container></p>
      </div></div>
      <div class="px-[24px] py-[20px]" *ngIf="!hayPuente"><p class="kb-hint m-0">{{ r.puente_nota || 'Este cierre no tiene cortes: no hay cruce con MT que mostrar.' }}</p></div>
      <div class="kb-table-envoltorio" *ngIf="hayPuente">
        <table class="kb-table">
          <thead class="kb-thead"><tr><th class="kb-th">Grupo</th><th class="kb-th kb-th-num">Pagos</th><th class="kb-th kb-th-num">USD</th></tr></thead>
          <tbody>
            <tr class="kb-tr"><td class="kb-td">Excluido por el cierre</td><td class="kb-td kb-td-num">{{ nn(r.puente_mt.excluido?.n) }}</td><td class="kb-td kb-td-num">{{ fu(r.puente_mt.excluido?.usd) }}</td></tr>
            <tr class="kb-tr"><td class="kb-td">Dinero de antes del inicio del contrato</td><td class="kb-td kb-td-num">{{ nn(r.puente_mt.antes_inicio?.n) }}</td><td class="kb-td kb-td-num">{{ fu(r.puente_mt.antes_inicio?.usd) }}</td></tr>
            <tr class="kb-tr"><td class="kb-td">Ya descontado</td><td class="kb-td kb-td-num">{{ nn(r.puente_mt.ya_descontado?.n) }}</td><td class="kb-td kb-td-num">{{ fu(r.puente_mt.ya_descontado?.usd) }}</td></tr>
            <tr class="kb-tr"><td class="kb-td">Fees cobrados en cuentas MT (100 % CT)</td><td class="kb-td kb-td-num"></td><td class="kb-td kb-td-num">{{ fu(r.puente_mt.fees_usd) }}</td></tr>
            <tr class="kb-tr font-semibold"><td class="kb-td">Base para descontar</td><td class="kb-td kb-td-num">{{ nn(r.puente_mt.base?.n) }}</td><td class="kb-td kb-td-num">{{ fu(r.puente_mt.base?.usd) }}</td></tr>
          </tbody>
        </table>
      </div>
      <div class="px-[24px] py-[14px]" *ngIf="hayPuente && r.puente_mt.regla"><p class="kb-hint m-0">{{ r.puente_mt.regla }}</p></div>
    </section>

    <!-- Utilidad del cierre -->
    <section class="kb-card min-w-0">
      <div class="kb-card-header"><div>
        <h2 class="kb-card-title">Utilidad del cierre</h2>
        <p class="kb-card-desc">Lo que le queda a CT de este cierre: comisión, flat fee y fees.</p>
      </div></div>
      <div class="kb-table-envoltorio">
        <table class="kb-table">
          <thead class="kb-thead"><tr><th class="kb-th">Concepto</th><th class="kb-th kb-th-num">Bs</th><th class="kb-th kb-th-num">USD</th></tr></thead>
          <tbody>
            <tr class="kb-tr"><td class="kb-td">Comisión</td><td class="kb-td kb-td-num">{{ fb(r.pasos.comision.bs) }}</td><td class="kb-td kb-td-num">{{ fu(r.pasos.comision.usd) }}</td></tr>
            <tr class="kb-tr"><td class="kb-td">Flat fee</td><td class="kb-td kb-td-num">{{ fb(r.pasos.flat.bs) }}</td><td class="kb-td kb-td-num">{{ fu(r.pasos.flat.usd) }}</td></tr>
            <tr class="kb-tr font-semibold"><td class="kb-td">Utilidad del cierre<span class="kb-td-sub block">Margen {{ pc(r.utilidad.margen_pct) }} del crédito liquidado</span></td><td class="kb-td kb-td-num">{{ fb(r.utilidad.bs) }}</td><td class="kb-td kb-td-num">{{ fu(r.utilidad.usd) }}</td></tr>
          </tbody>
        </table>
      </div>
      <div class="px-[24px] py-[14px]"><p class="kb-hint m-0">Los fees de lo recibido en cuentas CT se suman en el reporte «Cuentas CT»; aquí no entran.</p></div>
    </section>

    <section class="kb-card min-w-0" *ngIf="nLotes || r.lotes?.length">
      <div class="px-[24px] py-[20px]"><p class="m-0 text-sm text-muted-foreground">{{ nLotes === 1 ? '1 lote' : nLotes + ' lotes' }} en este cierre. Antes de pagar: compara el Neto de la consola al abrir el cierre con {{ fb(r.pasos.neto.bs) }}; si no sale, no generes el lote.</p></div>
    </section>
  </ng-container>
</div>

<ng-template #skTarjetas>
  <section class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4" aria-label="Cargando el resumen">
    <div class="kb-card p-[18px] flex flex-col gap-1.5 min-w-0" *ngFor="let i of esqueleto">
      <span class="kb-skeleton h-5 w-24"></span>
      <span class="kb-skeleton h-[39px] w-3/4"></span>
      <span class="kb-skeleton h-4 w-1/2"></span>
    </div>
  </section>
</ng-template>

<ng-template #skResto>
  <ng-container *ngTemplateOutlet="skTabla"></ng-container>
  <ng-container *ngTemplateOutlet="skTabla"></ng-container>
  <ng-container *ngTemplateOutlet="skTabla"></ng-container>
</ng-template>

<ng-template #skTabla>
  <section class="kb-card min-w-0" aria-label="Cargando una tabla">
    <div class="kb-card-header"><div class="flex flex-col gap-2"><span class="kb-skeleton h-5 w-56"></span><span class="kb-skeleton h-4 w-80 max-w-full"></span></div></div>
    <div class="flex flex-col gap-3 px-[24px] py-[20px]">
      <span class="kb-skeleton h-10 w-full"></span>
      <span class="kb-skeleton h-8 w-full" *ngFor="let i of filasGris"></span>
    </div>
  </section>
</ng-template>
